export const UserSerializer = (data) => {
    if(data)
    return {
        id: data.user_id,
        tenant_id: data.tenant_id,
        email: data.email,
        username: data.username,
        fullname: data.fullname,
        group_id: data.group_id,
        group_status: data.group_status,
        is_active: data.is_active,
        last_login_time: data.last_login_time,
        role_id: data.role_id,
        date_of_inset: data.date_of_inset,
        user_of_insert: data.user_of_insert,
        user_of_change: data.user_of_change,
        date_of_change: data.user_of_change,
        accessToken: data.accessToken,
        theme: data.theme,
    }
    return null
};

export const UserListSerializer = (data) => {
    const records= data&&data.content&&data.content.map((user)=>{
        return UserSerializer(user)
    }).filter(obj=>obj);
    if(data)
    return{
        records: records,
        current_page: data.current_page,
        is_first_page: data.is_first_page,
        is_last_page: data.is_last_page,
        is_sorted: data.is_sorted,
        page_size: data.page_size,
        search: data.search,
        sort_order: data.sort_order,
        sorted_column: data.sorted_column,
        total_elements: data.total_elements,
        total_pages: data.total_pages,

    }

    else
    return null
}